module.exports = __webpack_public_path__ + "static/media/tournaments-menu-active-icon.f09a7304.svg";